import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import PrivRoute from "./Components/PrivRoute";
import LogIn from "./Pages/LogIn/LogIn";
import PagoExitoso from "./Pages/Pagos/PagoExitoso";
import './App.css'
import Registro from "./Pages/LogIn/Registro/Registro";
import Panel from "./Pages/Panel/Panel";
import PanelPrincipal from "./Pages/PanelPrincipal/PanelPrincipal";
import { message, notification } from "antd5";
import { login, hasSigned, logout } from "./store/actions/user";
import { seleccionarEmpresaHasSigned } from "./store/actions/empresa";
import { connect } from "react-redux";
import RecuperarContrasena from './Pages/RecuperarContrasena/RecuperarContrasena';
import CambiarContrasena from './Pages/CambiarContrasena/CambiarContrasena';
import axios from "axios";
import kiosko from "./Pages/Kiosko/Kiosko";
import ActivoPublico from "./Pages/ActivoPublico/ActivoPublico";
import PuntoDeVentaPag from "./Pages/PuntoDeVenta/PuntoDeVenta";
import presentacionPersonal from "./Pages/presentacionPersonal/presentacionPersonal";
import TerminosYCondiciones from "./Pages/TerminosYCondiciones/TerminosYCondiciones";
import PoliticaCancelacion from "./Pages/PoliticaDeCancelacion/PoliticaDeCancelacion";
import AvisoDePrivacidad from "./Pages/AvisoDePrivacidad/AvisoDePrivacidad";
import CondicionesServicioWhatsApp from "./Pages/CondicionesServicioWhatsApp/CondicionesServicioWhatsApp";
import { HotkeyProvider } from "./Components/HotKeyContext";

class App extends Component {
  state = {
    redirect: null,
    firstPathname: window.location.pathname,
    loading: true
  }
  componentDidMount(){
    notification.config({
      placement: 'topRight',
      duration: 30,
    });
    const firstPathname = window.location.pathname
    // Ficha publica del QR de un equipo CMMS: sin sesion y SIN el Redirect de abajo
    // (ese recorta la ruta al primer segmento y perderia el token).
    if(firstPathname.startsWith('/activoCMMS/')){
      this.setState({ loading: false })
    }else if(firstPathname.slice(0,12) === '/pagoExitoso' || firstPathname.slice(0,9) === '/registro' || firstPathname.slice(0,20) === '/recuperarContrasena' || firstPathname.slice(0,18) === '/cambiarContrasena' || firstPathname.slice(0,12) === '/pagoFallido' || firstPathname.slice(0,7) === '/kiosko' || firstPathname.slice(0,21) === '/presentacionPersonal' || firstPathname.slice(0,23) === '/terminosYCondiciones' || firstPathname.slice(0,20) === '/politicaCancelacion' || firstPathname.slice(0,18) === '/avisoDePrivacidad' || firstPathname.slice(0,18) === '/puntoDeVenta' || firstPathname.slice(0,32) === '/condicionesServicioWhatsApp'){
      const redirect = (
        <Redirect to={window.location.href.split('/', 4)[3]}/>
      )
      this.setState({redirect , loading: false})
    }else{
      this.props
      .hasSigned()
      .then((data) => {
        if (data.success === 1) {
          if(data.data.empresa){
            this.props.seleccionarEmpresaHasSigned({
              id: data.data.empresa._id, 
              nombre: data.data.empresa.nombre,
              rfc:  data.data.empresa.rfc,
              certificada: data.data.empresa.certificada, 
              certificadaDM: data.data.empresa.certificadaDM,
              automatica: data.data.empresa.automatica,
              envios: data.data.empresa.envios,
              embarques: data.data.empresa.embarques,
              fletes: data.data.empresa.fletes,
              marbetes: data.data.empresa.marbetes,
              complementoDetallista: data.data.empresa.complementoDetallista,
              complementoSeriesPersonalizadas: data.data.empresa.complementoSeriesPersonalizadas,
              insumosXCliente: data.data.empresa.insumosXCliente,
              cargarXmlPrevio: data.data.empresa.cargarXmlPrevio,
              puntoDeVenta: data.data.empresa.puntoDeVenta,
              activarPagare: data.data.empresa.activarPagare,
              modulosMezcal: data.data.empresa.modulosMezcal,
              modulosConsignaciones: data.data.empresa.modulosConsignaciones,
              equipoMedico: data.data.empresa.equipoMedico,
              taxidermia: data.data.empresa.taxidermia,
              comodatoFechaEntregaObligatoria: data.data.empresa.comodatoFechaEntregaObligatoria,
              ventaOnline: data.data.empresa.ventaOnline,
              appMovil: data.data.empresa.appMovil,
              checadaRemota: data.data.empresa.checadaRemota,
              verificacionFacial: data.data.empresa.verificacionFacial,
              conteos: data.data.empresa.conteos,
              cotizadorPorInsumo: data.data.empresa.cotizadorPorInsumo,
              lotesCaducidades: data.data.empresa.lotesCaducidades,
              filtrosAvanzadosInsumos: data.data.empresa.filtrosAvanzadosInsumos,
              duplicarVentas: data.data.empresa.duplicarVentas,
              programarRecordatorioCxC:data.data.empresa.programarRecordatorioCxC,
              nomina: data.data.empresa.nomina,
              controlAsistencia: data.data.empresa.controlAsistencia,
              workbenchRequisiciones : data.data.empresa.workbenchRequisiciones,
              mostrarSugerenciasRequisicion: data.data.empresa.mostrarSugerenciasRequisicion,
              moduloCalidad: data.data.empresa.moduloCalidad,
              camposCalidad: data.data.empresa.camposCalidad,
              crm: data.data.empresa.crm,
              evaluacionProveedores: data.data.empresa.evaluacionProveedores,
              whatsapp: data.data.empresa.whatsapp,
              escuela: data.data.empresa.escuela,
              mostrarPdfMovimientosInventario: data.data.empresa.mostrarPdfMovimientosInventario,
              decimalesEmpresa: data.data.empresa.decimalesEmpresa,
              consultarProveedoresOnline: data.data.empresa.consultarProveedoresOnline,
              quitarImpuestosOpcionalVentas: data.data.empresa.quitarImpuestosOpcionalVentas,
              desactivarCargaExcelInsumosVentas: data.data.empresa.desactivarCargaExcelInsumosVentas,
              prorrateoDesCostos: data.data.empresa.prorrateoDesCostos,
              mostrarComplementoPagoFacturas: data.data.empresa.mostrarComplementoPagoFacturas,
              vencimientoDesdeRecepcionFactura: data.data.empresa.vencimientoDesdeRecepcionFactura,
              anticipos: data.data.empresa.anticipos,
              permitirCambiarClienteVenta: data.data.empresa.permitirCambiarClienteVenta,
              permitirCambiarInsumoVenta: data.data.empresa.permitirCambiarInsumoVenta,
              permitirBajaLotesReemplazoVentas: data.data.empresa.permitirBajaLotesReemplazoVentas,
              permitirEditarRemisionVenta: data.data.empresa.permitirEditarRemisionVenta,
              permitirDividirVentaPorPartidas: data.data.empresa.permitirDividirVentaPorPartidas,
              autorizacionesRapidas: data.data.empresa.autorizacionesRapidas,
              moduloWms: data.data.empresa.moduloWms,
              moduloActivosFijos: data.data.empresa.moduloActivosFijos,
              moduloCMMS: data.data.empresa.moduloCMMS,
              moduloHoteleria: data.data.empresa.moduloHoteleria,
              moduloRMA: data.data.empresa.moduloRMA,
              moduloProduccion: data.data.empresa.moduloProduccion,
              moduloBOM: data.data.empresa.moduloBOM,
              transporte: data.data.empresa.transporte,
              portalClientes: data.data.empresa.portalClientes,
              creditos: data.data.empresa.creditos,
              moduloRMACompras: data.data.empresa.moduloRMACompras,
              cerrarPedidos: data.data.empresa.cerrarPedidos,
              finiquitarPedidos: data.data.empresa.finiquitarPedidos,
              semanaPedidos: data.data.empresa.semanaPedidos,
              apartarInsumosPedidos: data.data.empresa.apartarInsumosPedidos,
              pdfApartadoPedido: data.data.empresa.pdfApartadoPedido,
              entregarInsumosPedidos: data.data.empresa.entregarInsumosPedidos,
              generarRequisicionPedidos: data.data.empresa.generarRequisicionPedidos,
              importarPedidosIMSS: data.data.empresa.importarPedidosIMSS,
              editarCotizacionesTerminadas: data.data.empresa.editarCotizacionesTerminadas,
              finiquitarCotizaciones: data.data.empresa.finiquitarCotizaciones,
              formatoRequerimientoCotizaciones: data.data.empresa.formatoRequerimientoCotizaciones,
              complementoPSWPedidos: data.data.empresa.complementoPSWPedidos,
              editarTodasLasPolizas: data.data.empresa.editarTodasLasPolizas,
              verPolizaAlRealizarMovimiento: data.data.empresa.verPolizaAlRealizarMovimiento,
              buscadorMenu: data.data.empresa.buscadorMenu,
              verComoSistemaOCPorDefecto: data.data.empresa.verComoSistemaOCPorDefecto,
              imprimirObservacionesOCPorDefecto: data.data.empresa.imprimirObservacionesOCPorDefecto,
              separacionInsumosSimpleOC: data.data.empresa.separacionInsumosSimpleOC,
              separacionInsumosPorClienteOC: data.data.empresa.separacionInsumosPorClienteOC,
              separacionInsumosPorDiaOC: data.data.empresa.separacionInsumosPorDiaOC,
              preCotizacionIngenieria: data.data.empresa.preCotizacionIngenieria,
              ordenesMaquila: data.data.empresa.ordenesMaquila,
              activarEtiquetaEntregaPedido: data.data.empresa.activarEtiquetaEntregaPedido,
              unidadTiempoProduccion: data.data.empresa.unidadTiempoProduccion,
              altaEmpleadoPorPasos: data.data.empresa.altaEmpleadoPorPasos,
            })
          }
          const redirect = (
            <Redirect to={firstPathname === '/' || firstPathname === '/login' ? '/panelPrincipal' : firstPathname}/>
          )
          this.setState({redirect, loading: false})
          // window.location.replace(firstPathname === '/' ? '/panelPrincipal' : firstPathname);
        } else {
          const redirect = (
            <Redirect to='/login'/>
          )
          this.setState({redirect , loading: false})
          if (firstPathname !== '/' && firstPathname !== '/login') {
            if(firstPathname === '/logout1'){
              notification.info({
                message: 'Se ha cerrado la sesión por inactividad',
                duration: 2.0,
              })
            }else if(firstPathname === '/logout2'){
              notification.info({
                message: 'Se ha cerrado la sesión por falta de pago',
                duration: 2.0,
              })
            }else{
              message.warning(data.err);
            }
          }
        }
      })
      .catch((err) => {
        if (firstPathname !== '/' && firstPathname !== '/login') {
          notification.error({
            message: "Adventencia",
            description: "No se puede acceder a la página sin iniciar sesión",
            duration: 1.5
          });
          const redirect = (
            <Redirect to='/login'/>
          )
          this.setState({redirect , loading: false})
        }
      });
    }
    let cookieEnds
    let cookieEnds2
    axios.interceptors.response.use(async (responsePeticion) => {
      const loggedIn = this.props.isUserLoggedIn
      if(loggedIn){
        if(cookieEnds !== undefined){
        clearTimeout(cookieEnds)
        }
        cookieEnds = setTimeout(() => {
          clearTimeout(cookieEnds)
          notification.info({
            message: 'La sesión se cerrará en 1 minuto por inactividad.',
            duration: 0.7 
          })
        }, (this.props.tiempoSesion - 60000))
        if(cookieEnds2 !== undefined){
          clearTimeout(cookieEnds2)
        }
        cookieEnds2 = setTimeout(async () => {
          clearTimeout(cookieEnds2)
          clearTimeout(cookieEnds)
          await this.props.hasSigned().then(async (responseSigned) => {
            if (responseSigned.success === 1) {
              if(responseSigned.data.empresa){
                await this.props.seleccionarEmpresaHasSigned({
                  id: responseSigned.data.empresa._id,
                  nombre: responseSigned.data.empresa.nombre,
                  rfc:  responseSigned.data.empresa.rfc,
                  certificada: responseSigned.data.empresa.certificada,
                  certificadaDM: responseSigned.data.empresa.certificadaDM,
                  automatica: responseSigned.data.empresa.automatica,
                  envios: responseSigned.data.empresa.envios,
                  embarques: responseSigned.data.empresa.embarques,
                  fletes: responseSigned.data.empresa.fletes,
                  marbetes: responseSigned.data.empresa.marbetes,
                  complementoDetallista: responseSigned.data.empresa.complementoDetallista,
                  complementoSeriesPersonalizadas: responseSigned.data.empresa.complementoSeriesPersonalizadas,
                  insumosXCliente: responseSigned.data.empresa.insumosXCliente,
                  cargarXmlPrevio: responseSigned.data.empresa.cargarXmlPrevio,
                  puntoDeVenta: responseSigned.data.empresa.puntoDeVenta,
                  activarPagare: responseSigned.data.empresa.activarPagare,
                  modulosMezcal: responseSigned.data.empresa.modulosMezcal,
                  modulosConsignaciones: responseSigned.data.empresa.modulosConsignaciones,
                  equipoMedico: responseSigned.data.empresa.equipoMedico,
                  taxidermia: responseSigned.data.empresa.taxidermia,
                  comodatoFechaEntregaObligatoria: responseSigned.data.empresa.comodatoFechaEntregaObligatoria,
                  ventaOnline: responseSigned.data.empresa.ventaOnline,
                  appMovil: responseSigned.data.empresa.appMovil,
                  checadaRemota: responseSigned.data.empresa.checadaRemota,
                  verificacionFacial: responseSigned.data.empresa.verificacionFacial,
                  conteos: responseSigned.data.empresa.conteos,
                  cotizadorPorInsumo: responseSigned.data.empresa.cotizadorPorInsumo,
                  lotesCaducidades: responseSigned.data.empresa.lotesCaducidades,
                  filtrosAvanzadosInsumos: responseSigned.data.empresa.filtrosAvanzadosInsumos,
                  duplicarVentas: responseSigned.data.empresa.duplicarVentas,
                  programarRecordatorioCxC:responseSigned.data.empresa.programarRecordatorioCxC,
                  nomina: responseSigned.data.empresa.nomina,
                  controlAsistencia: responseSigned.data.empresa.controlAsistencia,
                  workbenchRequisiciones : responseSigned.data.empresa.workbenchRequisiciones,
                  mostrarSugerenciasRequisicion: responseSigned.data.empresa.mostrarSugerenciasRequisicion,
                  moduloCalidad: responseSigned.data.empresa.moduloCalidad,
                  camposCalidad: responseSigned.data.empresa.camposCalidad,
                  crm: responseSigned.data.empresa.crm,
                  evaluacionProveedores: responseSigned.data.empresa.evaluacionProveedores,
                  whatsapp: responseSigned.data.empresa.whatsapp,
                  escuela: responseSigned.data.empresa.escuela,
                  mostrarPdfMovimientosInventario: responseSigned.data.empresa.mostrarPdfMovimientosInventario,
                  decimalesEmpresa: responseSigned.data.empresa.decimalesEmpresa,
                  consultarProveedoresOnline: responseSigned.data.empresa.consultarProveedoresOnline,
                  quitarImpuestosOpcionalVentas: responseSigned.data.empresa.quitarImpuestosOpcionalVentas,
                  desactivarCargaExcelInsumosVentas: responseSigned.data.empresa.desactivarCargaExcelInsumosVentas,
                  prorrateoDesCostos: responseSigned.data.empresa.prorrateoDesCostos,
                  mostrarComplementoPagoFacturas: responseSigned.data.empresa.mostrarComplementoPagoFacturas,
                  vencimientoDesdeRecepcionFactura: responseSigned.data.empresa.vencimientoDesdeRecepcionFactura,
                  anticipos: responseSigned.data.empresa.anticipos,
                  permitirCambiarClienteVenta: responseSigned.data.empresa.permitirCambiarClienteVenta,
                  permitirCambiarInsumoVenta: responseSigned.data.empresa.permitirCambiarInsumoVenta,
                  permitirBajaLotesReemplazoVentas: responseSigned.data.empresa.permitirBajaLotesReemplazoVentas,
                  permitirEditarRemisionVenta: responseSigned.data.empresa.permitirEditarRemisionVenta,
                  permitirDividirVentaPorPartidas: responseSigned.data.empresa.permitirDividirVentaPorPartidas,
                  autorizacionesRapidas: responseSigned.data.empresa.autorizacionesRapidas,
                  moduloWms: responseSigned.data.empresa.moduloWms,
                  moduloActivosFijos: responseSigned.data.empresa.moduloActivosFijos,
                  moduloCMMS: responseSigned.data.empresa.moduloCMMS,
                  moduloHoteleria: responseSigned.data.empresa.moduloHoteleria,
                  moduloRMA: responseSigned.data.empresa.moduloRMA,
                  moduloProduccion: responseSigned.data.empresa.moduloProduccion,
                  moduloBOM: responseSigned.data.empresa.moduloBOM,
                  transporte: responseSigned.data.empresa.transporte,
                  portalClientes: responseSigned.data.empresa.portalClientes,
                  creditos: responseSigned.data.empresa.creditos,
                  moduloRMACompras: responseSigned.data.empresa.moduloRMACompras,
                  cerrarPedidos: responseSigned.data.empresa.cerrarPedidos,
                  finiquitarPedidos: responseSigned.data.empresa.finiquitarPedidos,
                  semanaPedidos: responseSigned.data.empresa.semanaPedidos,
                  apartarInsumosPedidos: responseSigned.data.empresa.apartarInsumosPedidos,
                  pdfApartadoPedido: responseSigned.data.empresa.pdfApartadoPedido,
                  entregarInsumosPedidos: responseSigned.data.empresa.entregarInsumosPedidos,
                  generarRequisicionPedidos: responseSigned.data.empresa.generarRequisicionPedidos,
                  importarPedidosIMSS: responseSigned.data.empresa.importarPedidosIMSS,
                  editarCotizacionesTerminadas: responseSigned.data.empresa.editarCotizacionesTerminadas,
                  finiquitarCotizaciones: responseSigned.data.empresa.finiquitarCotizaciones,
                  formatoRequerimientoCotizaciones: responseSigned.data.empresa.formatoRequerimientoCotizaciones,
                  complementoPSWPedidos: responseSigned.data.empresa.complementoPSWPedidos,
                  editarTodasLasPolizas: responseSigned.data.empresa.editarTodasLasPolizas,
                  verPolizaAlRealizarMovimiento: responseSigned.data.empresa.verPolizaAlRealizarMovimiento,
                  buscadorMenu: responseSigned.data.empresa.buscadorMenu,
                  verComoSistemaOCPorDefecto: responseSigned.data.empresa.verComoSistemaOCPorDefecto,
                  imprimirObservacionesOCPorDefecto: responseSigned.data.empresa.imprimirObservacionesOCPorDefecto,
                  separacionInsumosSimpleOC: responseSigned.data.empresa.separacionInsumosSimpleOC,
                  separacionInsumosPorClienteOC: responseSigned.data.empresa.separacionInsumosPorClienteOC,
                  separacionInsumosPorDiaOC: responseSigned.data.empresa.separacionInsumosPorDiaOC,
                  preCotizacionIngenieria: responseSigned.data.empresa.preCotizacionIngenieria,
                  ordenesMaquila: responseSigned.data.empresa.ordenesMaquila,
                  activarEtiquetaEntregaPedido: responseSigned.data.empresa.activarEtiquetaEntregaPedido,
                  unidadTiempoProduccion: responseSigned.data.empresa.unidadTiempoProduccion,
                  altaEmpleadoPorPasos: responseSigned.data.empresa.altaEmpleadoPorPasos,
                })
              }
            } else {
              this.props.logout().then((responseLogout) => {
                if(responseLogout.success === 1){
                  window.location.replace("/logout1");
                }else{
                  message.warning(responseLogout.err);
                }
              })
            }
          })
        }, this.props.tiempoSesion)
      }

      //Checar para que no se regrese

      if(Number(responsePeticion?.status) === 204){
        window.location.replace("/logout1");

      }else if(Number(responsePeticion?.status) === 205){
        window.location.replace("/panelPrincipal");
        notification.info({
          message: responsePeticion?.data ? responsePeticion?.data : "No puede utilizar esta empresa por falta de pago",
          duration: 2.0,
        })
      }else{
        return responsePeticion;
      }
      // Do something with response data
    }, function (error) {
      // Do something with response error
      return Promise.reject(error);
    });
  }
  render() {
    if(this.state.loading){
      return null
    }
    return (
      <BrowserRouter>
         <HotkeyProvider>
        {this.state.redirect}
        <Switch>
          <Route path='/puntoDeVenta/:id' component={PuntoDeVentaPag} />
          <Route path='/kiosko' component={kiosko} />
          <Route path='/activoCMMS/:token' component={ActivoPublico} />
          <Route path='/pagoExitoso' component={PagoExitoso} />
          <Route path='/terminosYCondiciones' component={TerminosYCondiciones} />
          <Route path='/politicaCancelacion' component={PoliticaCancelacion} />
          <Route path='/avisoDePrivacidad' component={AvisoDePrivacidad} />
          <Route path='/condicionesServicioWhatsApp' component={CondicionesServicioWhatsApp} />
          <Route path='/login' component={LogIn} />
          <Route path='/registro' component={Registro} />
          <Route path='/recuperarContrasena' component={RecuperarContrasena} />
          <Route path='/cambiarContrasena' component={CambiarContrasena} />
          <Route path='/presentacionPersonal' component={presentacionPersonal} />
          <PrivRoute path='/panelPrincipal' component={PanelPrincipal} />
          <PrivRoute path='/panel' component={Panel} />
        </Switch>
        </HotkeyProvider>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isUserLoggedIn: state.user.isUserLoggedIn,
    tiempoSesion: state.user.tiempoSesion,
  };
};

export default connect(mapStateToProps, { login, hasSigned, seleccionarEmpresaHasSigned, logout })(App);
